import { forwardRef } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import type {
  TDialogOverlayElement,
  TDialogOverlayProps,
} from "@/ui/components/overlay/Dialog/Dialog.config";
import { cn } from "@/ui/lib/utils";

export const DialogOverlay = forwardRef<TDialogOverlayElement, TDialogOverlayProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <DialogPrimitive.Overlay
      data-component="DialogOverlay"
      ref={ref}
      className={cn(
        "fixed inset-0 z-40 bg-sys-opacity-dark-20",
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        className,
      )}
      {...props}
    />
  ),
);

DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
